<template>
  <v-layout data-qa="activateuser-layout-vgisin">
    <v-overlay v-if="loaderEnabled" :opacity="0.5" data-qa="activateuser-overlay-ekp2l">
      <v-progress-circular
        :color="primaryColor"
        :size="70"
        :width="7"
        indeterminate
        class="circular-loader"
       data-qa="activateuser-progress-circular-7z5arr"></v-progress-circular>
    </v-overlay>
    <v-flex v-if="showInputFields" xs12 sm12 md12 lg12 xl12 data-qa="activateuser-flex-4dqkco">
      <!-- <font class="subtitle-2 font-weight-medium">{{
        $t("registerUser.formHeadline")
      }}</font> -->
       <!--Form Tabs Control-->
      <v-tabs
        v-if ="showCustomerTypeTabs"
        v-model="customerTypeCurrentTab"
        @change="handleCustomerTypeTabChange"
        :color="primaryColor"
       data-qa="activateuser-tabs-unmcys">
        <v-tab v-for="(item, i) of customerTypeTabLabels" :key="i" :data-qa="`activateuser-tab-ca8w0j-${i}`">
          <!-- <v-icon
            dark
            left
            :data-qa="`activateuser-icon-g71mw-${i}`">
            {{ item.icon }}
          </v-icon> -->
          <dob-icon :iconKey="item.icon" dark left/>
          <font class="subtitle-1 text-capitalize font-weight-bold">{{
            item.label
          }}</font>
        </v-tab>
      </v-tabs>
      <v-card-subtitle data-qa="activateuser-card-subtitle-5tsyda">
        {{ currentSubTitle }}
      </v-card-subtitle>
      <v-tabs
        v-if="showParamTypeTabs"
        v-model="currentTab"
        @change="handleParamTypeTabChange"
        :color="primaryColor"
        dense
       data-qa="activateuser-tabs-cjk36n">
        <v-tab v-for="(item, i) of tabLabels" :key="i" :data-qa="`activateuser-tab-kavcv-${i}`">
          <font class="subtitle-1 text-capitalize font-weight-bold">{{
            item
          }}</font>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="currentTab" data-qa="activateuser-tabs-items-dirac">
        <v-tab-item data-qa="activateuser-tab-item-4fxi6">
          <v-flex xs12 sm12 md10 lg10 xl10 data-qa="activateuser-flex-l43sb">
            <!-- <v-row no-gutters justify="center" data-qa="activateuser-row-v1x394">
              <v-switch
                v-model="isSmeCustomerEnabled"
                @change="setSMERelatedData"
                label="SME Customer"
                :color="primaryColor"
               data-qa="activateuser-switch-8axww5"></v-switch>
            </v-row> -->
            <Form
              :config="{
                label: '',
                name: 'ActivateUser',
                isEnabled: true,
                form: schema.activateUserModel,
              }"
            ></Form>
          </v-flex>
        </v-tab-item>
         <v-tab-item data-qa="activateuser-tab-item-39xd53">
          <v-flex xs12 sm12 md10 lg10 xl10 data-qa="activateuser-flex-3edfp8">
            <!-- <v-row no-gutters justify="center" data-qa="activateuser-row-gprs5g">
              <v-switch
                v-model="isSmeCustomerEnabled"
                @change="setSMERelatedData"
                label="SME Customer"
                :color="primaryColor"
               data-qa="activateuser-switch-ewz6cv"></v-switch>
            </v-row> -->
            <Form
              :config="{
                label: '',
                name: 'ActivateUser',
                isEnabled: true,
                form: schema.activateUserModel,
              }"
            ></Form>
          </v-flex>
        </v-tab-item>
      </v-tabs-items>
    <v-flex xs12 sm12 md10 lg10 xl10 data-qa="activateuser-flex-6fn3gb">
      <div class="ma-1" v-if="showCustomerSupportInfo" data-qa="activateuser-div-kx9iq">
        <v-alert
          icon="mdi-information-outline" class="v-alert--info"
         data-qa="activateuser-alert-meuj3">
          <span class="body-2 font-weight-regular" data-qa="activateuser-span-xkteje">{{ $t('common.customerSupportInfo') }}</span>
        </v-alert>
      </div>
    </v-flex>
    <v-flex class="d-flex justify-start" data-qa="activateuser-flex-4d10n">
      <v-card-actions data-qa="activateuser-card-actions-un0cuc">
        <v-spacer data-qa="activateuser-spacer-l5gd39"  />
        <v-btn
          @click="proceedOnNext"
          :color="primaryColor"
          :disabled="enableNext"
          style="margin-left: 32px;"
          class="text-capitalize font-weight-bold white--text py-2 px-4"
           data-qa="activateuser-btn-it36f">{{ $t("common.next") }}</v-btn
        >
      </v-card-actions>
    </v-flex>
    </v-flex>

    <!-- Create Login ID -->
    <!-- New Password -->
    <v-flex v-if="showNewPasswordSection" data-qa="activateuser-flex-030iiu">
      <!-- Common Set Password Component -->
      <SetPassword
        @onResetPassword="onResetPassword"
        :config="{
          enableLoginId: true,
          enableUserId: false,
          roundedPwdBtn: true,
          enableOtpModal: false,
          showSuccessModal: false,
          btnLabel: 'Next',
          fromScreen: 'activateUser'
        }"
      />
    </v-flex>

    <!-- Password set status -->
    <v-flex v-if="showPasswordResetSuccess" xs12 sm12 md9 lg8 xl8 data-qa="activateuser-flex-fsbtis">
      <p v-if="triggeredUserActivation" class="subtitle-1 font-weight-medium" data-qa="activateuser-p-yc0py5">
        <inline-svg
          v-if="accountCreationSuccess"
          :src="getTickIcon()"
          width="90"
          height="90"
          aria-label="Tick Icon"
          data-qa="pwd-success"
        ></inline-svg>
        <v-icon
          v-else
          :color="errorColor"
          medium
          class="pr-4"
          data-qa="pwd-failure"
          >mdi-close-circle</v-icon
        >
      </p>
      <p data-qa="activateuser-p-i94lkv">
        {{ passwordChangeStatus }} {{ $t('registerUser.loginInfo') }}
      </p>
      <v-card-actions data-qa="activateuser-card-actions-stsy8">
        <v-btn
          @click="goBackToLoginScreen"
          :color="primaryColor"
          data-qa="savePassword"
          class="text-capitalize white--text py-2 px-4"
          >Go To Login</v-btn
        >
      </v-card-actions>
    </v-flex>
  </v-layout>
</template>

<script>
import '@/styles/pages/login/activateUser.scss'
import CommonService from '@/service/commonService.js'
import SetPassword from '@/components/DOB-SetPassword/SetPassword.vue'
import getFormConfig from '@/util/formUtility.js'
import event from '@/util/event'
import { required } from '@/core/_helpers/validationRules'
import moment from 'moment'
import handleError from '../../../core/_helpers/errorHandler'
import preLoginMixin from '@/core/mixins/preloginScreensMixin'

export default {
  name: 'ActivateUser',
  components: {
    SetPassword,
    Form: () => import('@/components/DOB-Form/Form.vue')
  },
  mixins: [preLoginMixin],
  data () {
    return {
      models: {},
      isPhoneNumberPresent: false,
      isSmeCustomerEnabled: false,
      // isEmailPresent: true,
      isLoginIdValid: true,
      allFieldsAreValid: false,
      enableNext: true,
      showInputFields: true,
      showNewPasswordSection: false,
      showPasswordResetSuccess: false,
      accountCreationSuccess: false,
      passwordChangeStatus: '',
      newPassword: '',
      accountCreated: false,
      defaultConfig: this.$appSettings.defaultConfigurations.loginPageScreens.activateUserScreen,
      loginMode: this.$appSettings.defaultConfigurations.loginPageScreens.activateUserScreen.userModeTabs,
      enableOTP: this.$appSettings.defaultConfigurations.loginPageScreens.activateUserScreen.enableOTP,
      paramType: this.$appSettings.defaultConfigurations.loginPageScreens.activateUserScreen.customerIdOrAccountNumberTabs,
      defaultSelectedLoginMode: this.$appSettings.defaultConfigurations.loginPageScreens.defaultSelectedLoginMode,
      showCustomerSupportInfo: this.$appSettings.defaultConfigurations.showCustomerSupportInfo,
      userPassword: '',
      userPasswordAgain: '',
      mobileNumber: '',
      partyID: '',
      dateOfBirth: '',
      lastName: '',
      idNumber: '',
      loginID: '',
      errorLogin: false,
      errorMessage: undefined,
      showOTPSection: false,
      setPasswordSection: false,
      showCreateLoginSection: false,
      menu: false,
      schema: {
        activateUserModel: { exists: true }
      },
      showCustomerTypeTabs: false,
      customerTypeTabLabels: [
        { icon: 'activateuser_personaltab', label: 'Personal' },
        { icon: 'activateuser_smetab', label: 'SME' }
      ],
      customerTypeCurrentTab: 0,
      showParamTypeTabs: false,
      isCustomerParamEnabled: false,
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        }
      },
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      requiredRules: [(v) => Boolean(v)],
      userPasswordAgainVal: true,
      userPasswordVal: true,
      loaderEnabled: false,
      currentTab: 0,
      currentSubTitle: '',
      tabLabels: [
        this.$t('registerUser.tabLabels.customerId'),
        this.$t('registerUser.tabLabels.accNumber')
      ],
      otpData: undefined,
      triggeredUserActivation: false,
      loginIdMinlength: this.$appSettings.defaultConfigurations.loginPageScreens.usernameMinLength,
      IBANAccountFormatEnabled: this.$appSettings.defaultConfigurations.loginPageScreens.activateUserScreen.enableIBANAccountFormat,
      isdCodeSelectionDisabled: this.$appSettings.defaultConfigurations.loginPageScreens.activateUserScreen.disableISDCodeSelection
    }
  },
  async created () {
    this.loaderEnabled = true
    this.currentSubTitle = this.$t('login.actionScreen.subHeadings.activateUserLabel')
    this.setTabs()
    await this.getFormData(`ActivateUser-${this.$i18n.locale}`)
    this.loaderEnabled = false
    event.$on('isValid', (arg) => {
      this.enableNext = !arg
    })
    event.$on('checkLoginScreenAction', (arg) => {
      arg && this.formMethods(arg)
    })
    event.$on('resetPwdSuccess', async (args) => {
      if (args.status) {
        this.otpData = {
          otp: args.otpData.otp,
          referenceNumber: args.otpData.referenceNumber
        }
        this.newPassword = args.password
        await this.createB2Cuser()
      }
    })
  },
  updated () {
    this.setParamTabs()
  },
  methods: {
    getTickIcon () {
      return this.getSvgIconSrc('Tick')
    },
    /** Set Tabs to display - 'Profile' / 'SME'
     * Display tabs only if default login form selection is 'Both'
    */
    setTabs () {
      // Login form is configurable, values -  'Personal' or 'SME' or 'Both'
      // when default form is SME set to show the input field and add the show class
      const loginMode = this.loginMode.toLowerCase()
      // Set the defaultSelectedLoginMode as per configurations
      const defaultSelectedLoginMode = this.defaultSelectedLoginMode.toLowerCase()
      switch (loginMode) {
        case 'sme':
          this.showCustomerTypeTabs = false
          this.isSmeCustomerEnabled = true
          this.customerTypeCurrentTab = 1
          break
        case 'personal':
          this.customerTypeCurrentTab = 0
          this.showCustomerTypeTabs = false
          this.isSmeCustomerEnabled = false
          break
        case 'both':
          this.showCustomerTypeTabs = true
          this.customerTypeCurrentTab = defaultSelectedLoginMode === 'personal' ? 0 : 1
          this.isSmeCustomerEnabled = this.customerTypeCurrentTab === 1
          break
      }
      this.setConfigTabs()
    },
    setConfigTabs () {
      // Parameter types tab - customerId / accountNumber / Both
      let paramType = ''
      paramType = this.customerTypeCurrentTab === 0
        ? this.paramType.forPersonal.toLowerCase()
        : this.paramType.forSme.toLowerCase()
      switch (paramType) {
        case 'customerid':
          this.currentTab = 0
          this.showParamTypeTabs = false
          this.isCustomerParamEnabled = true
          break
        case 'accountnumber':
          this.currentTab = 1
          this.showParamTypeTabs = false
          this.isCustomerParamEnabled = false
          break
        case 'both':
          this.showParamTypeTabs = true
          this.currentTab = 0
          this.isCustomerParamEnabled = true
          break
      }
    },
    setParamTabs () {
      if (this.currentTab === 0 && this.schema.activateUserModel.schema) {
        this.schema.activateUserModel.schema.customerID.hidden = false
        this.schema.activateUserModel.schema.customerID.rules.push(required('Required'))
        this.schema.activateUserModel.schema.accountNumber.hidden = true
        this.schema.activateUserModel.schema.accountNumber.rules = []
        this.schema.activateUserModel.schema.lastName.hidden = true
        this.schema.activateUserModel.schema.lastName.rules = []
        this.schema.activateUserModel.schema.countryCode['menu-props'].contentClass = this.customerTypeCurrentTab === 1 ? 'custom-dropdown-sme' : 'custom-dropdown-custId'
      }
      if (this.currentTab === 1 && this.schema.activateUserModel.schema) {
        this.schema.activateUserModel.schema.lastName.hidden = false
        this.schema.activateUserModel.schema.lastName.rules.push(required('Required'))
        this.schema.activateUserModel.schema.accountNumber.hidden = false
        this.schema.activateUserModel.schema.accountNumber.rules.push(required('Required'))
        this.schema.activateUserModel.schema.customerID.hidden = true
        this.schema.activateUserModel.schema.customerID.rules = []
        this.schema.activateUserModel.schema.countryCode['menu-props'].contentClass = this.customerTypeCurrentTab === 1 ? 'custom-dropdown-sme' : 'custom-dropdown-accNo'
        if (this.accountType === 'IB') this.schema.activateUserModel.schema.accountNumber.label = this.$t('internationalPayments.payeeAccNoLabel')
      }
    },
    handleCustomerTypeTabChange () {
      if (this.customerTypeCurrentTab === 0) {
        this.isSmeCustomerEnabled = false
        this.currentSubTitle = this.$t('login.actionScreen.subHeadings.activateUserLabel')
      } else {
        this.isSmeCustomerEnabled = true
        this.currentSubTitle = this.$t('login.actionScreen.subHeadings.activateUserLabelSME')
      }
      // Set SME field
      // this.setSMERelatedData()
      this.setParamTabs()
      this.setConfigTabs()
      this.getFormData(`ActivateUser-${this.$i18n.locale}`)
    },
    handleParamTypeTabChange () {
      this.getFormData(`ActivateUser-${this.$i18n.locale}`)
      if (this.currentTab === 0) {
        this.isCustomerParamEnabled = true
      } else this.isCustomerParamEnabled = false
    },
    async onNext (customerIdFromPartySearch) {
      if (this.customerTypeCurrentTab === 1 && this.models.smeID) {
        const customerID = this.currentTab === 1 ? customerIdFromPartySearch : this.models.customerID
        if (await this.validateCustomerRelationDetails(customerID, this.models.smeID)) {
          this.proceed(customerIdFromPartySearch)
        } else {
          this.partyNotFound('invalidDetails')
        }
      } else {
        this.proceed(customerIdFromPartySearch)
      }
    },
    proceed (customerIdFromPartySearch) {
      this.storeData(customerIdFromPartySearch)
      this.onPartyVerification()
    },
    storeData (customerIdFromPartySearch) {
      this.$store.dispatch('profileStore/setProfileData', {
        partyDetails: {
          customerID: this.models?.customerID || customerIdFromPartySearch,
          dateOfBirth: this.models?.dateOfBirth,
          emailAddress: this.models?.emailAddress,
          firstName: this.models?.firstName,
          lastName: this.models?.lastName,
          idNumber: this.models?.idNumber,
          idTypes: this.models?.idTypes,
          phoneNumber: this.models?.phoneNumber,
          countryCode: this.models?.countryCode?.split('_')[0]
        }
      })
    },
    onPartyVerification () {
      // After OTP validates
      // this.showCreateLoginSection = true
      this.showInputFields = false
      this.showNewPasswordSection = true
      this.showOTPSection = false
    },
    onResetPassword () {
      this.showNewPasswordSection = false
      this.showPasswordResetSuccess = true
    },
    goBackToLoginScreen () {
      event.$emit('goBackToLoginScreen', true)
    },
    async getFormData (formName) {
      try {
        const componentSchema = await CommonService.getFormData(formName)
        const data = getFormConfig(componentSchema)
        this.schema.activateUserModel = data
        this.models = data.model
        const countryCodes = JSON.parse(localStorage.getItem('countryCode')) || []
        this.schema.activateUserModel.schema.countryCode.items = JSON.parse(localStorage.getItem('countryCode')) || []

        // Show SME field
        this.setSMERelatedData(true)
        // set national id types
        if (
          this.schema.activateUserModel.schema &&
          this.schema.activateUserModel.schema.idTypes
        ) {
          const nationalIDType = JSON.parse(
            sessionStorage.getItem('PARTYIDTYPE')
          )
          if (nationalIDType) {
            const nationalIdTypesArr = []
            nationalIDType.forEach((code) => {
              nationalIdTypesArr.push({
                text: code.codeDescription,
                value: code.codeReference
              })
            })
            this.schema.activateUserModel.schema.idTypes.items = nationalIdTypesArr
          }
        }
        event.$emit('resetFormValidation', true)
        if (this.$appSettings.defaultConfigurations.countryISDCode && this.$appSettings.defaultConfigurations.defaultCountryCode && countryCodes) {
          this.schema.activateUserModel.schema.countryCode['item-value'] = (item) => `${item.dial_code}_${item.code}`
          const { countryISDCode, defaultCountryCode } = this.$appSettings.defaultConfigurations
          this.schema.activateUserModel.model.countryCode = `${countryISDCode}_${defaultCountryCode}`
        }
        if (this.isdCodeSelectionDisabled) this.schema.activateUserModel.schema.countryCode.disabled = true
        this.loaderEnabled = false
      } catch (e) {
        console.log(e)
      }
    },
    setSMERelatedData () {
      // Show SME field
      if (this.schema.activateUserModel.schema && this.schema.activateUserModel.schema.smeID) {
        this.schema.activateUserModel.schema.smeID.hidden = !this.isSmeCustomerEnabled
        this.isSmeCustomerEnabled ? this.schema.activateUserModel.schema.smeID.rules.push(required('Required')) : this.schema.activateUserModel.schema.smeID.rules = []
      }
    },
    proceedOnNext () {
      if (this.currentTab === 1) {
        this.getAccountDetails()
      } else this.partySearch()
    },
    async getAccountDetails () {
      if (this.currentTab === 1 && this.models.accountNumber) {
        const accDetails = await CommonService.checkAccountStatusFromBff(this.models.accountNumber, this.accountType)
        if (accDetails && accDetails.accountStatus && (['activated', 'normal'].includes(accDetails.accountStatus.toLowerCase()) || (this.allowInactiveAccountPreLoginOperations && accDetails.accountStatus.toLowerCase() === 'inactive'))) {
          this.partySearch()
        } else if ((accDetails && accDetails.causes && accDetails.causes[0]?.code === '40280164') || (accDetails.error && accDetails?.error?.causes && accDetails.error.causes[0].code === '40280164')) {
          this.partySearch()
        } else if ((accDetails && accDetails.causes && accDetails.causes[0]?.code === '20600027') || (accDetails.error && accDetails?.error?.causes && accDetails.error.causes[0].code === '20600027')) {
          // Prelogin screen - customer is on the blacklist or invalid status
          // this.partyNotFound('pendingVerification')
          this.partySearch()
        } else {
          this.partyNotFound('invalidDetails')
        }
      }
    },
    async partySearch () {
      // Validate user against entered info
      // Party search API call payload
      this.loaderEnabled = true
      let partySearchData = {}
      if (this.currentTab === 0) {
        if (this.models.idNumber && this.models.idTypes) {
          partySearchData = {
            // extra info
            customerId: this.models.customerID,
            schema: this.schema.activateUserModel.schema,
            // actual payload
            identifier: this.models.idNumber,
            idType: this.models.idTypes,
            partyType: '1062',
            partyName: this.models.firstName ? `${this.models.firstName}%` : null,
            dateOfBirthOrFormation: this.models.dateOfBirth ? moment(this.models.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            mobile: !!this.models.phoneNumber.length > 0 ? this.models.phoneNumber : '',
            email: this.models?.emailAddress || null
          }
        } else {
          partySearchData = {
            // extra info
            customerId: this.models.customerID,
            schema: this.schema.activateUserModel.schema,
            // actual payload
            partyName: this.models.firstName ? `${this.models.firstName}%` : null,
            dateOfBirthOrFormation: this.models.dateOfBirth ? moment(this.models.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            mobile: this.models.phoneNumber.length > 0 ? this.models.phoneNumber : '',
            email: this.models?.emailAddress || null
          }
        }
      } else {
        if (this.models.idNumber && this.models.idTypes) {
          partySearchData = {
            // extra info
            customerId: this.models.customerID,
            // actual payload
            // identifier: this.models.idNumber,
            idNumber: this.models.idNumber,
            idType: this.models.idTypes,
            // partyType: '1062',
            // partyName: this.models.firstName ? `${this.models.firstName}%` : null,
            firstName: this.models.firstName,
            lastName: this.models.lastName,
            // dateOfBirthOrFormation: this.models.dateOfBirth ? moment(this.models.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            dateOfBirth: this.models.dateOfBirth ? moment(this.models.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            mobile: this.models.phoneNumber.length > 0 ? this.models.phoneNumber : '',
            email: this.models?.emailAddress || null,
            accountNumber: this.models.accountNumber,
            accountType: this.accountType
          }
        } else {
          partySearchData = {
            // extra info
            customerId: this.models.customerID,
            // actual payload
            // partyName: this.models.firstName ? `${this.models.firstName}%` : null,
            firstName: this.models.firstName,
            lastName: this.models.lastName,
            // dateOfBirthOrFormation: this.models.dateOfBirth ? moment(this.models.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            dateOfBirth: this.models.dateOfBirth ? moment(this.models.dateOfBirth, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
            mobile: this.models.phoneNumber.length > 0 ? this.models.phoneNumber : '',
            email: this.models?.emailAddress || null,
            accountNumber: this.models.accountNumber,
            accountType: this.accountType
          }
        }
      }
      let partyDataValidation
      try {
        partyDataValidation = this.currentTab === 1
          ? await CommonService.partySearchByAccount(partySearchData)
          : await CommonService.partyUserSearch(partySearchData)
      } catch (e) {
        // Network / transport level failure
        this.loaderEnabled = false
        return
      }

      // Empty object or null indicates potential connection drop / backend unreachable
      if (!partyDataValidation || (typeof partyDataValidation === 'object' && Object.keys(partyDataValidation).length === 0)) {
        this.loaderEnabled = false
        return
      }

      if (partyDataValidation && partyDataValidation?.validationResponse) {
        this.partyId = partyDataValidation?.customerId
        this.onNext(partyDataValidation?.customerId)
      } else {
        const errorMsgKey = this.getPartySearchErrorMessageKey(partyDataValidation)
        this.partyNotFound(errorMsgKey)
      }
      this.loaderEnabled = false
    },
    async validateCustomerRelationDetails (customerID, smeID) {
      const checkResp = await CommonService.validateCustomerRelationDetails(customerID, smeID)
      return typeof checkResp === 'boolean' && checkResp === true
    },
    partyNotFound (data) {
      this.$store.dispatch('appStore/setAppData', {
        message: {
          title: 'Error',
          width: 400,
          persistent: true,
          saveButton: this.$t('common.okay'),
          saveCallback: this.resetScreen,
          content: this.$t(`registerUser.validationStatus.${data}`),
          type: 'error',
          component: 'dob-modal'
        }
      })
    },
    getPartySearchErrorMessageKey (error) {
      const kycStatuses = {
        '002': 'PENDING',
        '003': 'NON_COMPLIANT',
        '004': 'CAUTIONARY',
        KYCCHECKDUE: 'SCHEDULED'
      }

      if (!error?.cause) return 'invalidDetails'

      if (this.customerTypeCurrentTab === 1 && error.cause === 'pendingVerification' && error.kycCurrentStatus && kycStatuses[error.kycCurrentStatus]) {
        return `KYC_STATUS_${kycStatuses[error.kycCurrentStatus]}`
      }

      return error.cause
    },
    resetScreen () {
      console.log('clear user data')
    },
    formMethods ({ e, action }) {
      if (action === 'blur') {
        switch (e.key) {
          case 'phoneNumber':
            this.checkPhoneValidation()
            break
          case 'customerID':
            this.checkPhoneValidation()
            break
          default:
        }
      } else if (action === 'input') {
        if (e.key === 'countryCode' && this.models.countryCode && this.models.phoneNumber) this.checkPhoneValidation()
        if (this.models.accountNumber && this.models.accountNumber.length) {
          if (this.accountType === 'IB') {
            this.models.accountNumber = this.models.accountNumber.toUpperCase()
          }
        }

        if (e.key === 'idTypes') {
          if (this.models.idTypes && this.models.idTypes.length) {
            this.schema.activateUserModel.schema.idNumber.rules.push(required('Required'))
            // this.schema.activateUserModel.schema.idNumber.id.push(required('Required'))
            // this.schema.activateUserModel.model.idNumber = undefined
          } else {
            this.schema.activateUserModel.schema.idNumber.rules = []
            // this.schema.activateUserModel.model.idNumber = undefined
          }
          event.$emit('resetFormValidation', true)
        }

        if (e.key === 'idNumber') {
          if (this.models.idNumber && this.models.idNumber.length) {
            this.schema.activateUserModel.schema.idTypes.rules.push(required('Required'))
          } else {
            this.schema.activateUserModel.schema.idTypes.rules = []
            // this.schema.activateUserModel.model.idTypes = undefined
          }
          event.$emit('resetFormValidation', true)
        }

        switch (e.key) {
          case 'idTypes':
            this.changeIDtype()
            break
          default:
        }
      } else {
        this.loginID = e
        this.checkLoginID()
      }
    },
    async checkPhoneValidation () {
      /** Validate mobile number
       * for SME -> Pass party Customer Id & mobile number
       * for Personal -> pass just the mobile number
      */
      let resp = false
      const cc = this.models?.countryCode?.split('_')[0] || ''
      const body = {
        mobileNumber: cc && this.models.phoneNumber ? `${cc}${this.models.phoneNumber}` : ''
      }
      // Personal/SME and Customer ID
      // {
      //   mobileNumber: this.models.phoneNumber ? this.models.phoneNumber.replace(/\s/g, '') : '',
      //   customerId: this.models.customerID || ''
      // }
      this.loaderEnabled = true
      if (this.models.phoneNumber && this.models.phoneNumber.length > 4) {
        resp = await CommonService.validatePhoneNumber(body)
        this.isPhoneNumberPresent = resp === true
        // If response is true, phoneno is registered
        // If response is false, phoneno isn't registered
        if (this.isPhoneNumberPresent) {
          this.schema.activateUserModel.schema.phoneNumber.hidden = true
          this.schema.activateUserModel.schema.phoneNumber.appendIcon = ''
          this.schema.activateUserModel.schema.phoneNumber.hidden = false
          this.schema.activateUserModel.schema.phoneNumber['persistent-hint'] = true
          this.schema.activateUserModel.schema.phoneNumber.hint = this.$t('registerUser.validationStatus.mobileNumberExistence')
        } else {
          this.schema.activateUserModel.schema.phoneNumber.hidden = true
          this.schema.activateUserModel.schema.phoneNumber.hidden = false
          this.schema.activateUserModel.schema.phoneNumber.hint = ''
          this.schema.activateUserModel.schema.phoneNumber['persistent-hint'] = false
        }
        // this.isPhoneNumberPresent = false
      }
      this.loaderEnabled = false
    },
    async checkLoginID () {
      this.loaderEnabled = true
      const body = {
        userLoginId: this.loginID
      }
      if (this.loginID && this.loginID.length >= this.loginIdMinlength) {
        const resp = await CommonService.validateLoginID(body)
        this.isLoginIdValid = resp === false
        if (this.isLoginIdValid) {
          event.$emit('verifiedLoginID', true)
        } else {
          event.$emit('verifiedLoginID', false)
        }
      } else this.isLoginIdValid = false
      this.loaderEnabled = false
    },
    async createB2Cuser () {
      try {
        this.loaderEnabled = true
        const currentDate = new Date()
          .toJSON()
          .slice(0, 10)
          .split('-')
          .join('-')
        const body = {
          ...this.otpData,
          activeFlag: 'Y',
          activeFrom: currentDate,
          authenticationMethodCode: 'LOGINID_PASSWORD',
          bankCode: this.defaultConfig.bankCode,
          branchCode: this.defaultConfig.branchCode,
          channelCode: 'WEB',
          emailId: this.models?.emailAddress || '',
          emailVerifiedFlag: 'Y',
          mobileNumber: this.models?.phoneNumber || '',
          countryCode: this.models?.countryCode?.split('_')[0] || '',
          mobileVerifiedFlag: 'Y',
          password: this.newPassword,
          userLoginId: this.loginID,
          customerId: this.models.customerID || this.partyId,
          userCategoryCode: this.models.smeID ? 'CORPORATE_USER' : 'BANK_CUSTOMER',
          corporateCode: this.models.smeID ? this.models.smeID : ''
        }

        const resp = await CommonService.createB2Cuser(body)
        if (resp && resp.error) {
          if (['11400361', '11400360'].includes(resp.error.response.data.causes[0].code)) {
            event.$emit('prelogin_invalid_otp')
            this.loaderEnabled = false
            return
          } else if (resp.error.response.data.causes[0].code === 'FEUS-000040') {
            handleError(resp.error)
            event.$emit('reset_OTPField', true)
            this.loaderEnabled = false
            return
          }
          this.onResetPassword()
          this.accountCreationSuccess = false
          this.passwordChangeStatus = this.$t('registerUser.failureLabel')
        } else {
          this.onResetPassword()
          this.accountCreationSuccess = true
          this.passwordChangeStatus = this.$t('registerUser.successfullLabel')
        }
        this.triggeredUserActivation = true
        this.loaderEnabled = false
        this.newPassword = undefined
        this.loginID = undefined
        this.models.customerID = undefined
        this.models.phoneNumber = undefined
      } catch (e) {
        console.log(e)
      }
    },
    changeIDtype () {
      this.schema.activateUserModel.schema.idNumber.hidden =
        this.models.idTypes === ''
    }
  },
  watch: {
    currentTab () {
      this.setParamTabs()
    }
  },
  beforeDestroy () {
    event.$off('resetPwdSuccess')
    event.$off('IS_OTP_VALID')
  }
}
</script>
